import { esES } from "@mui/x-date-pickers/locales";
import config from "../../../config";
import axiosInstance from "../../../util/axiosInstance";
import axios from 'axios';
import { getToken } from "../../../util/Cookies";

// ✅ Fetch Catering Master Item List
export const getCateringItemMasterList = async (exclude_side_items) => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/catering-items/mst-list", {
      method: "GET",
      params: {exclude_side_items},
      headers: {
        Authorization: `${token}`,
      },
    });
    // console.log("called",response.data)

    if (response.status === 200) {
      return response.data.data;
    } else {
      throw new Error(response.message || "Unable to fetch catering item master list");
    }
  } catch (error) {
    console.error("❌ Error fetching catering item master list:", error);
  }
};

// ✅ Fetch Unit Type Master List
export const getCateringUnitTypeList = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/master/catUnitType", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    console.log("called",response.data)
    if (response.status === 200) {
      return response.data.data;
    } else {
      throw new Error(response.message || "Unable to fetch unit types");
    }
  } catch (error) {
    console.error("❌ Error fetching unit type list:", error);
  }
};

export const fetchProviderData = async () => {
  try {
    const response = await axiosInstance.get("/provider-types", {
      method: "GET",
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error("Network response was not ok");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getServiceProviderServices = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/services", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getCateringProviderServices = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/cuisine/meals-type", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getCateringProviderCuisines = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/cuisine/cuisine-types", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to get the provider cuisines"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getCateringProviderCategories = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/cuisine/categories", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to get the provider categories"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const addCateringProviderServices = async (cateringServices) => {
  const token = getToken();
  console.log("catering_Services",cateringServices)
  try {
    const response = await axiosInstance.post(
      "/catering-items",
      cateringServices,
      {
        method: "POST",
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    if (response.status === 201) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to add the catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const updateCateringProviderServices = async (cateringServices) => {
  const token = getToken();
  console.log("cateringServices",cateringServices)
  try {
    const response = await axiosInstance.put(
      "/catering-items",
      cateringServices,
      {
        method: "PUT",
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to add the catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const deleteCateringProviderServices = async (cateringServiceItems) => {
  const token = getToken();

  try {
    const response = await axiosInstance.delete("/catering-items", {
      method: "DELETE",
      headers: {
        Authorization: `${token}`,
      },
      data: cateringServiceItems,
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to add the catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getCateringProviderAddedServices = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/catering-items", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to get already added catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const addCateringProviderMenuImage = async (formData) => {
  console.log("FormData", formData);

  const token = getToken();

  try {
    const response = await axiosInstance.post("/gallery/upload", formData);
    if (response.status === 201) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to add the catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getPriestProviderEvents = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/priest/mappedEvents", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response?.data?.data || [];
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getPriestEvents = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/master/priestEventMaster", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response?.data?.data || [];
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getServiceProvidersByID = async (Id, Lat, Long, eventId) => {
  try {
    let url = `/provider?typeId=${Id}&latitude=${Lat}&longitude=${Long}&order=asc`;
    if (eventId != null) {
      url += `&eventTypeId=${eventId}`;
    }
    const response = await axiosInstance.get(url, {
      method: "GET",
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getPriestsListByLocation = async (Lat, Long, eventId) => {
  try {
    let url = `/priest/list?eventId=${eventId}&latitude=${Lat}&longitude=${Long}&order=desc`;
    const response = await axiosInstance.get(url, {
      method: "GET",
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getTentHouseListByLocationpost = async (Lat, Long, eventId, serviceIds) => {
  try {
    const url = `/tent-house/list-by-service?eventId=${eventId}&latitude=${Lat}&longitude=${Long}&order=asc`;

    const response = await axiosInstance.post(url, {
      serviceIds: serviceIds, // e.g., [8, 9]
    });

    if (response.status === 200) {
      
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
    throw error;
  }
};
export const getTentHouseListByLocation = async (Lat, Long, eventId) => {
  try {
    let url = `/tent-house/list?eventId=${eventId}&latitude=${Lat}&longitude=${Long}&order=asc`;
    const response = await axiosInstance.get(url, {
      method: "GET",
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const catering_includeditems = async()=>{
  try {
    const response = await axiosInstance.get('/catering-items/included-items')
    console.log("response of includeditems",response)
    return response.data.data
  } catch (error) {
    console.log("couldn't get the included items",error)
  }
}

export const getCateringListByLocation = async (Lat, Long, eventId,cateringdata) => {
  try {

    console.log("Sending payload:", JSON.stringify(cateringdata));
    let url = `/caterer/list-by-services?eventId=${eventId}&latitude=${Lat}&longitude=${Long}&order=asc`;
    const response = await axiosInstance.post(url,cateringdata, {
     headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    console.log("cateringdata",response)
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getProviderServicesByID = async (Id) => {
  try {
    const response = await axiosInstance.get(
      `/provider/services?providerId=${Id}`,
      {
        method: "GET",
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    // dispatch(profileFailuer(error.message));
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const fetchserviceitemssecond = async () => {
    try {
        const token = getToken();
        const response = await axiosInstance.get('/v1/tent-house/services', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Network response was not ok');
        }
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
    }
};


// 1️⃣ Add new category (with optional services)
export const addCategoryToTentHouse = async ({ cat_name, cat_description, items = [] }) => {
  try {
    const response = await axiosInstance.post("/v1/tent-house/categories", {
      cat_name,
      cat_description,
      items,
    });
    return response.data; // { success, data }
  } catch (error) {
    console.error("Error adding category:", error);
    throw error;
  }
};

// 2️⃣ Add items under existing category
export const addItemsToCategory = async (categoryId, items = []) => {
  try {
    console.log("adding data",items)
    const response = await axiosInstance.post(
      `/v1/tent-house/categories/${categoryId}/items`,
      { items }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding items to category:", error);
    throw error;
  }
};

// 3️⃣ Update existing category
export const updateCategory = async (categoryId, { cat_name, cat_description }) => {
  try {
    const response = await axiosInstance.put(
      `/v1/tent-house/categories/${categoryId}`,
      { cat_name, cat_description }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating category:", error);
    throw error;
  }
};

// 4️⃣ Update existing service item
export const updateServiceItem = async (
  serviceId,
  {
    service_name,
    description,
    image_ids,
    image_mode,
  } = {} // default empty object to avoid destructure errors
) => {
  try {
    // Build request body dynamically (only include fields that are defined)
    const payload = {};
    if (service_name !== undefined) payload.service_name = service_name;
    if (description !== undefined) payload.description = description;
    if (image_ids !== undefined) payload.image_ids = image_ids;
    if (image_mode !== undefined) payload.image_mode = image_mode;

    console.log("🟢 Updating service:", serviceId, payload);

    const response = await axiosInstance.put(
      `/v1/tent-house/services/${serviceId}`,
      payload
    );

    return response.data;
  } catch (error) {
    console.error("❌ Error updating service item:", error);
    throw error;
  }
};



// need to change this
export const uploadsapiid = async (file, description = '') => {
  console.log("📤 [UPLOADSAPIID] Function called");
  console.log("📁 Received file:", {
    name: file?.name,
    type: file?.type,
    size: file?.size,
    constructor: file?.constructor?.name
  });
  console.log("📝 Description:", description);
  
  let formData = new FormData();
  formData.append('file', file);
  
  // Add description if provided
  if (description) {
    formData.append('description', description);
  }
  
  console.log("📦 FormData entries:");
  for (let pair of formData.entries()) {
    console.log(pair[0], pair[1]);
  }
  
  try {
    console.log("🚀 Making API request to upload endpoint...");
    const response = await axiosInstance.post('/gallery/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        console.log(`📊 Upload progress: ${percentCompleted}%`);
      }
    });
    
    console.log("✅ [UPLOADSAPIID SUCCESS] Upload completed");
    return response;
  } catch (error) {
    console.log("❌ [UPLOADSAPIID FAILED] Upload error");
    console.log("❌ Error:", error.message);
    if (error.response) {
      console.log("❌ Response status:", error.response.status);
      console.log("❌ Response data:", error.response.data);
    }
    throw error;
  }
};

export const uploadsmultipleimages_getids = async (files) => {
  try {
    const token = getToken(); // 🔐 your JWT or bearer token
    const formData = new FormData();

    // ✅ Append all files (backend should expect an array field name)
    // If backend expects multiple "file" fields:
    //     formData.append("file", file)
    // else if it expects "files[]", adjust accordingly.
    files.forEach((file) => formData.append("files", file));

    // 🔥 Send the request
    const response = await axiosInstance.post("/gallery/upload/multiple",
      formData   
    );

    console.log("✅ Upload successful:", response.data);
    return response.data; // assume response.data.files[] exists
  } catch (error) {
    console.error("❌ Upload failed:", error.response?.data || error.message);
    throw error;
  }
};

export const create_event_category = async (data) => {
  try {
    console.log("data",data)
     const response = await axiosInstance.post(`/event-categories/`, data);
    return response.data;

  } catch (error) {
    console.error('Error in updateEvencategoryImage:', error);       
  }
};
export const update_event_category = async (data,id) => {
  try {
    
     const response = await axiosInstance.put(`/event-categories/${id}`, data);
    return response.data;

  } catch (error) {
    console.error('Error in updateEvencategoryImage:', error);       
  }
};
export const create_event= async (data) => {
  try {
    
     const response = await axiosInstance.post(`/event-categories/events`, data);
    return response.data;

  } catch (error) {
    console.error('Error in updateEvencategoryImage:', error);       
  }
};
export const update_event = async (data,id) => {
  try {
    
     const response = await axiosInstance.put(`/event-categories/events/${id}`, data);
    return response.data;

  } catch (error) {
    console.error('Error in updateEvencategoryImage:', error);       
  }
};
export const updateEvencategoryImage = async (catid, imageId) => {
  try {
    console.log(`Updating event category ${catid} with image ${imageId}`);
    
    const response = await axiosInstance.put(`/event-categories/${catid}`, {
      image_id: imageId
    });

    console.log('Update response status:', response.status);
    console.log('Update response data:', response.data);

    // With axios, the response data is directly available in response.data
    return response.data;

  } catch (error) {
    console.error('Error in updateEvencategoryImage:', error);
    
    // Axios error handling
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      throw new Error(`Failed to update event category: ${error.response.data.error || error.response.statusText}`);
    } else if (error.request) {
      // The request was made but no response was received
      throw new Error('Failed to update event category: No response from server');
    } else {
      // Something happened in setting up the request that triggered an Error
      throw new Error(`Failed to update event category: ${error.message}`);
    }
  }
};
export const updateEventImage = async (eventId, imageId) => {
  try {
    console.log(`Updating event ${eventId} with image ${imageId}`);
    
    const response = await axiosInstance.put(`/event-categories/events/${eventId}`, {
      image_id: imageId
    });

    console.log('Update response status:', response.status);
    console.log('Update response data:', response.data);

    // With axios, the response data is directly available in response.data
    return response.data;

  } catch (error) {
    console.error('Error in updateEventImage:', error);
    
    // Axios error handling
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      throw new Error(`Failed to update event: ${error.response.data.error || error.response.statusText}`);
    } else if (error.request) {
      // The request was made but no response was received
      throw new Error('Failed to update event: No response from server');
    } else {
      // Something happened in setting up the request that triggered an Error
      throw new Error(`Failed to update event: ${error.message}`);
    }
  }
};

export const deletetentcategory = async(id)=>{
  try {
    const response = await axiosInstance.delete(`/v1/tent-house/categories/${id}`)
    return response
  } catch (error) {
   console.error(`Failed to delete category with id ${id}:`, error);
  }
}

export const deletetentservicewithid = async(id)=>{
  try {
    const response = await axiosInstance.delete(`/v1/tent-house/services/${id}`)
    return response
  } catch (error) {
   console.error(`Failed to delete service with id ${id}:`, error);
  }
}






export const uploadZipFileImages = async (zipFile) => {
  try {
    console.log("📤 Starting ZIP file upload...");

    // Create FormData
    const formData = new FormData();
    formData.append("Generated_Folders", zipFile); // Match the backend expectation

    // Make the API call using axiosInstance
    const response = await axiosInstance.post("/v1/tent-house/services/bulk-link-images", formData);

    console.log("✅ ZIP upload successful:", response.data);
    return {
      success: true,
      data: response.data,
      message: "ZIP file uploaded successfully"
    };

  } catch (error) {
    console.error("❌ ZIP upload failed:", error);
    
    let errorMessage = "Failed to upload ZIP file";
    if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }

    return {
      success: false,
      error: errorMessage,
      data: null
    };
  }
};

export const getTentHouseProviderServices = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/tent-house/services", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getTentHouseProviderAddedServices = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/tent-house/mappings", {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to get the provider details");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const deleteTentHouseProviderServices = async (
  tentHouseServiceItems
) => {
  const token = getToken();

  try {
    const response = await axiosInstance.delete("/tent-house/mappings", {
      method: "DELETE",
      headers: {
        Authorization: `${token}`,
      },
      data: tentHouseServiceItems,
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to add the catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const updateTentHouseProviderServices = async (tentHouseServices) => {
  const token = getToken();

  try {
    const response = await axiosInstance.put(
      "/tent-house/mappings",
      tentHouseServices,
      {
        method: "PUT",
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to update the tent house services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const addTentHouseProviderServices = async (tentHouseServices) => {
  const token = getToken();

  try {
    const response = await axiosInstance.post(
      "/tent-house/mappings",
      tentHouseServices,
      {
        method: "POST",
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    if (response.status === 201) {
      return response.data;
    } else {
      throw new Error(
        response.message || "Unable to add the catering services"
      );
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const syncTentHouseProviderServices = async (tentHouseServices) => {
  const token = getToken();
  try {
    const response = await axiosInstance.post(
      "/tent-house/sync-mappings",
      { services: tentHouseServices },
      {
        method: "POST",
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to sync tent house services");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const savePriestEvents = async (updatedData) => {
  const API_URL = "/priest/sync-priest-mappings"; // Adjust the endpoint as needed

  const token = getToken();
  try {
    const response = await axiosInstance.post(API_URL, {
      mappings: updatedData || [],
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message || "Unable to sync proist services");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

